import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { selectRouteData } from '@public-page/store/router';

@Component({
  selector: 'pub-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class HeaderComponent {
  routeData$ = this.store.select(selectRouteData);

  constructor(private store: Store) {}
}
